<template>
    <div class="hover-1-wrapper">
        <v-card
            elevation="2"
            class="reviews-badge"
            @click="$parent.showDialog()"
            :style="'background-color: ' + widget_data.widget.settings.background_color + '; color: ' + widget_data.widget.settings.text_color + ';'"
        >
            <div class="reviews-title">
                {{ ((widget_data.widget.settings.hover_1_title) ? widget_data.widget.settings.hover_1_title.replace('[reviews_nr]', widget_data.total_reviews).replace('[rating_nr]', widget_data.average_rating) : "Our Rating") }}
            </div>
            <div class="reviews-average">
                {{ widget_data.average_rating }}
            </div>

            <v-rating
                class="reviews-rating"
                :value="parseFloat(widget_data.average_rating)"
                :color="widget_data.widget.settings.star_color"
                dense
                half-increments
                readonly
                size="20"
            ></v-rating>

            <div class="reviews-read-link">
                <a href="javascript: void(0);" :style="'color: ' + widget_data.widget.settings.text_color + ';'">{{ ((widget_data.widget.settings.hover_1_subtitle) ? widget_data.widget.settings.hover_1_subtitle.replace('[reviews_nr]', widget_data.total_reviews).replace('[rating_nr]', widget_data.average_rating) : "Read our ") + widget_data.total_reviews + " reviews" }}</a>
            </div>
        </v-card>

        <div v-if="widget_data.widget.subscription.stripe_id == 'starter'" class="reviews-footer" :style="'color: ' + widget_data.widget.settings.footer_text_color + '; text-align: center;'">
            Powered by <a href="https://Lead Finder.com/" target="review-grower-external" :style="'color: ' + widget_data.widget.settings.footer_link_color + ';'">Review Grower</a>
        </div>
    </div>
</template>

<script>
import Header from '@/views/panel/Business/Widgets/Render/Header.vue';
import Review from '@/views/panel/Business/Widgets/Render/Review.vue';

export default {
    props: ["widget_data", "fw"],

    components: {
        Header,
        Review
    }
}
</script>

<style type="text/css" scoped>
    .hover-1-wrapper {
        width: 210px;
        padding-bottom: 10px;
    }
</style>